import { Button } from 'antd';
import { ReactNode } from 'react';

interface IProps {
  block?: boolean;
  children: ReactNode;
  className?: string;
  icon?: ReactNode;
  htmlType?: 'submit';
  disabled?: boolean;
  onClick?: () => void;
}

function AppButton(props: IProps) {
  return (
    <Button
      block={props.block}
      className={`h-10 text-base font-semibold bg-primary border-darkBlue border-b-2 shadow-none rounded-lg disabled:opacity-70 ${props.className}`}
      type="primary"
      htmlType={props.htmlType ?? 'button'}
      disabled={props.disabled}
      icon={props.icon}
      onClick={props.onClick}
    >
      {props.children}
    </Button>
  );
}

export default AppButton;
